import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentDashComponent } from './student-dash/student-dash.component';
import { StudentEditComponent } from './student-edit/student-edit.component';
import { StudentProfileComponent } from './student-profile/student-profile.component';
import { NewDashboardComponent } from './new-dashboard/new-dashboard.component';

const routes: Routes = [
  
      {
        path:'profile',component:StudentDashComponent
      },
      {
        path:'student-profile',component:StudentProfileComponent
      },
      {
        path:'student-edit/:id',component:StudentEditComponent
      },
      {
        path:'student-reports',component:NewDashboardComponent
      },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentDashboardRoutingModule { }
